'use client';

import { ReactComponent as CircleExclamation } from '@assets/icons/circle-exclamation.svg';

import { Heading, useTheme, VStack } from '@chakra-ui/react';

import { Button } from 'ui/Button';
import { Text } from 'ui/Text';

type GiftCardErrorModalProps = {
  serial: string;
  onBack: () => void;
  bg?: string;
};

const GiftCardErrorModal = ({
  serial,
  onBack,
  bg = 'transparent'
}: GiftCardErrorModalProps) => {
  const {
    colors: {
      palette: {
        components: {
          giftCardList: { errorModal: styles }
        }
      }
    }
  } = useTheme();

  return (
    <VStack
      align='center'
      justify='center'
      position='fixed'
      width='100vw'
      height='100vh'
      top='0'
      left='0'
      bg={bg}
      zIndex='9999'
      backdropFilter='blur(10px)'
    >
      <VStack
        bg={styles.bg}
        py={{ base: '30px', sm: '50px' }}
        px='20px'
        borderRadius='20px'
        boxShadow='lg'
        textAlign='center'
        w='full'
        maxW={{ base: '90%', sm: 'container.sm' }}
        gap={{ base: '20px', lg: '30px' }}
      >
        <Heading
          fontSize={{ base: '22px', md: '28px', lg: '38px' }}
          fontWeight={{ base: 400, sm: 600 }}
          color={styles.title}
          textAlign='center'
        >
          Sorry, Invalid Gift Card
        </Heading>
        <VStack w='full' gap={0}>
          <CircleExclamation width={100} height={100} fill={styles.iconColor} />

          <Text
            mt={{ base: '15px', md: '30px' }}
            fontSize={{ base: '24px', md: '32px' }}
            color={styles.serialColor}
          >
            {serial}
          </Text>
          <Text
            textTransform='uppercase'
            fontSize={{ base: '14px', md: '18px' }}
            color={styles.description}
          >
            Not a valid or active gift card
          </Text>
        </VStack>

        <Button colorScheme='black' w='150px' padding={0} onClick={onBack}>
          Back
        </Button>
      </VStack>
    </VStack>
  );
};

export default GiftCardErrorModal;
